import { useNavigate, useRouter } from '@tanstack/react-router';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { sendEmailOtpPin, sendSmsOtpPin } from 'store/otp/otp-actions';
import { RootState } from 'store/reducer';
import { useGetProfileQuery } from 'store/slices/profile-api';
import { Process } from 'types/otp';
import { OTP_LENGTH } from 'utils/constants';
import maskEmail from 'utils/mask-email';
import maskNumber from 'utils/mask-number';
import EnterOtp from '../EnterOtp/EnterOtp';
import messages from './messages';
import BackButton from 'components/BackButton/BackButton';

export const VerifyOtp = ({
  onChangeOtp,
  canNavigateBack,
  error,
  isLoading,
  type = 'EMAIL',
  removeErrorFunction,
  darkText,
  title,
  errorMessage,
  process,
}: {
  onChangeOtp: (otp: string) => void;
  canNavigateBack?: boolean;
  error?: boolean;
  isLoading?: boolean;
  type: string;
  removeErrorFunction?: () => void;
  darkText?: boolean;
  title?: string;
  errorMessage?: string;
  process: Process;
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const router = useRouter();

  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const { data: userProfileResponse } = useGetProfileQuery();

  const numberWithDialCode = userProfileResponse?.msisdn || '';
  const email = userProfileResponse?.email || '';
  const viewMessages = messages[language][type];

  const sendOtp = async () => {
    if (type === 'SMS') dispatch(sendSmsOtpPin(process));
    if (type === 'EMAIL') dispatch(sendEmailOtpPin(process));
  };
  useEffect(() => {
    sendOtp();
  }, []);

  useEffect(() => {
    if (removeErrorFunction) removeErrorFunction();

    return () => {
      if (removeErrorFunction) removeErrorFunction();
    };
  }, []);

  const onChangeOtpHandler = (otp: string) => {
    if (otp.length >= OTP_LENGTH) onChangeOtp(otp);
    if (otp.length < 6 && removeErrorFunction) removeErrorFunction();
  };

  const maskedPhoneNumber = maskNumber(numberWithDialCode);
  const maskedEmail = maskEmail(email);

  return (
    <div className="relative w-full flex justify-center">
      <EnterOtp
        title={title || viewMessages.title}
        subtitle={viewMessages.subtitle(
          type === 'SMS' ? maskedPhoneNumber : maskedEmail,
        )}
        onChangeOtp={onChangeOtpHandler}
        resendOtp={sendOtp}
        hasError={error}
        type={type}
        isLoading={isLoading}
        darkText={darkText}
        errorMessage={errorMessage}
        process={process}
      />
      {canNavigateBack && !isLoading && (
        <>
        <BackButton className={'lg:absolute fixed w-full text-left lg:bg-body-background mt-1 ml-0 pl-6 lg:-mt-4 pt-2 lg:ml-0 lg:pl-0 lg:pt-2'} onClick={() => router.history.back()} />
        </>
      )}
    </div>
  );
};

export default VerifyOtp;
